import React from 'react';
import { useObservable } from 'react-use-observable';

import { Alert } from 'antd';

import { numberToBRL } from 'v2/helpers/money';
import { anticipationService } from 'v2/services/anticipation';

function AnticipateStep() {
  const [anticipationBalance] = useObservable(() => anticipationService.getCurrentBalance(), []);
  const anticipationFormatted = typeof anticipationBalance === 'number' ? numberToBRL(anticipationBalance) : '-';

  return (
    <>
      <p className='text-text-heading text-sm leading-[150%] font-normal'>Saldo disponível para antecipação</p>
      <div className='my-3.5 flex items-center justify-between text-base leading-[150%] text-[#546E7A]'>
        <span>Valor:</span>
        <strong>{anticipationFormatted}</strong>
      </div>

      <div className='pb-4'>
        <Alert
          className='p-[0.7rem] text-xs shadow-none'
          type='info'
          showIcon
          message={
            <>
              Você tem <strong>{anticipationFormatted}</strong> disponível para antecipação, deseja antecipar o valor?
            </>
          }
        />
      </div>
    </>
  );
}

export default AnticipateStep;
